<div class="news-popup-wrapper" [class.open]="open">
  <div class="news-popup-backdrop" (click)="onBackdropClick()"></div>
  <div class="news-popup-container" (click)="$event.stopPropagation()">
    <button type="button" class="news-popup-close" (click)="close()" aria-label="Close">
      <ion-icon name="close-outline"></ion-icon>
    </button>
    <div class="news-popup-content">
      <!-- GENERIC: image + title + message + action -->
      <div
        class="news-dynamic-body"
        *ngIf="payload?.template_code === 'GENERIC'"
      >
        <img
          *ngIf="payload?.imageUrl"
          [src]="payload.imageUrl"
          [alt]="payload?.title || 'News'"
          class="news-generic-image"
        />
        <h2 class="news-title">
          {{ payload?.title }}
        </h2>

        <p class="news-message">
          {{ payload?.message }}
        </p>

        <div class="news-actions">
          <button type="button" class="news-primary-btn" (click)="close()">
            {{ payload?.doneLabel || 'OK' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
